export default __webpack_public_path__ + "static/media/Danielyan.aa7572cf.png";